import { Alert, Box, Button, CircularProgress, Link, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { Link as RouterLink, useSearchParams } from 'react-router-dom'
import { useConfirmEmailChangeMutation } from '@store/api/authApi'

const ConfirmEmailChange: React.FC = () => {
  const [searchParams] = useSearchParams()
  const [confirmEmailChange, { isLoading }] = useConfirmEmailChangeMutation()
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending')
  const [message, setMessage] = useState('Confirming your email change...')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setStatus('error')
      setMessage('This confirmation link is missing a token. Request a new email change from your profile.')
      return
    }

    confirmEmailChange({ token })
      .unwrap()
      .then(() => {
        setStatus('success')
        setMessage('Email address updated. Please sign in with your new email.')
      })
      .catch((err: { data?: { message?: string }; message?: string }) => {
        setStatus('error')
        setMessage(err?.data?.message || err?.message || 'This confirmation link is invalid or expired.')
      })
  }, [confirmEmailChange, searchParams])

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto' }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Confirm Email Change
      </Typography>
      {isLoading && status === 'pending' && (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress />
        </Box>
      )}
      {status !== 'pending' && (
        <Alert severity={status === 'success' ? 'success' : 'error'} sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      <Box textAlign="center">
        <Link component={RouterLink} to="/auth/login">
          <Button variant="contained">Back to Login</Button>
        </Link>
      </Box>
    </Box>
  )
}

export default ConfirmEmailChange
